<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <div :class="{ printMe: false }">
        <v-toolbar color="orange">
          <v-toolbar-title>عمل مرتجع شراء</v-toolbar-title>
          <v-divider class="mx-2" inset vertical></v-divider>

          فاتورة مرتجع شراء جديدة
          <!-- <v-btn color="blue">فاتورة جديدة</v-btn> -->
          <!-- <v-btn color="blue">فاتورة قديمة</v-btn> -->
          <v-flex xs12 sm6 md3>
            <v-text-field
              height="10"
              outline
              @keyup.enter="search_fatwora_import_by_code"
              v-model="importer_search_name"
              label="كود الفاتورة"
            ></v-text-field>
          </v-flex>
        </v-toolbar>
        <v-card>
          <v-card-text>
            <v-form ref="form">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md3>
                    <b> كود الفاتورة </b>
                    :
                    {{ importer_fatwora_original.code }}
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <b> كود الورقة </b>
                    :
                    {{ importer_fatwora_original.paper_code }}
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <b> السعر قبل </b>
                    :
                    {{ importer_fatwora_original.price }}
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <b> الخصم</b>
                    :
                    {{ importer_fatwora_original.fatwora_dicount }}
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <b> السعر النهائي </b>
                    :
                    {{ importer_fatwora_original.final_price }}
                  </v-flex>

                  <v-flex xs12 sm6 md3>
                    <b> اسم المورد </b>
                    :
                    {{ importer_fatwora_original.importer_name }}
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <b> اسم السداد </b>
                    :
                    {{ importer_fatwora_original.sdad_type_name }}
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <b> اسم الموظف </b>
                    :
                    {{ importer_fatwora_original.emp_name }}
                  </v-flex>
                  <br />
                </v-layout>
                <v-divider class=" my-2 " inset horizontal></v-divider>
                <v-layout>
                  <v-flex xs12 sm6 md3>
                    <b> المجموع </b>
                    :
                    {{ fatwora_price }}
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <b> القيمة المسترجعة من التخفيض </b>
                    :
                    <input
                      type="text"
                      v-model="importer_fatwora_reback.fatwora_dicount_back"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <b> السعر النهائي </b>
                    :
                    {{ fatwora_final_price }}
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-autocomplete
                      :key="counter"
                      outline
                      v-model="select_store"
                      :items="stores"
                      item-text="name"
                      item-value="id"
                      label="أختر  المخزن"
                      persistent-hint
                      return-object
                      single-line
                    >
                      <template v-slot:append-outer>
                        <v-slide-x-reverse-transition mode="out-in">
                        </v-slide-x-reverse-transition>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-divider class=" my-1" inset horizontal></v-divider>
                <v-divider class=" my-1" inset horizontal></v-divider>
                <v-data-table
                  :headers="headers2"
                  :items="importer_fatwora_reback_items"
                  class="elevation-1"
                  :search="search"
                  :loading="loading"
                  :rows-per-page-items="rowsPerPageItems"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.item_name }}</td>
                    <td>{{ props.item.item_num }}</td>
                    <td>
                      <input
                        style="width:50px"
                        type="number"
                        v-model="props.item.item_num_reback"
                      />
                    </td>
                    <td>
                      {{
                        (props.item.item_num_remain = calc_remain(
                          props.item.item_num,
                          props.item.item_num_reback
                        ))
                      }}
                    </td>
                    <td>{{ props.item.price }}</td>
                    <td>
                      {{
                        (props.item.total_reback_price = gettotalpriceitem(
                          props.item.item_num_reback,
                          props.item.price
                        ))
                      }}
                    </td>
                  </template>
                </v-data-table>
              </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat>الغاء</v-btn>
            <v-btn color="blue darken-1" flat @click="save('form2')">حفظ</v-btn>
          </v-card-actions>
        </v-card>
        <br />

        <v-data-table
          v-if="importer_fatworas_reback_of_code.length > 0"
          :items="importer_fatworas_reback_of_code"
          class="elevation-1"
          :headers="headers"
          :rows-per-page-items="rowsPerPageItems"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.code }}</td>
            <td class="text-xs-right">{{ props.item.final_price }}</td>
            <td class="text-xs-right">{{ props.item.importer_name }}</td>
            <td class="text-xs-right">{{ props.item.emp_name }}</td>
            <td class="text-xs-right">{{ props.item.created_at }}</td>
            <td>
              <v-icon small class="ml-4" @click="detailItem(props.item)">
                book
              </v-icon>
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
          <template slot="no-data">
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
        </v-data-table>
      </div>

      <v-dialog v-model="detail_dialog" width="800" dark style="padding:10px">
        <v-card>
          <v-card-title class="headline orange lighten-2" primary-title>
            تفاصيل المرتجع
          </v-card-title>

          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm6 md4>
                الكود :
                {{ item_detail.code }}
              </v-flex>
              <v-flex xs12 sm6 md4>
                المورد :
                {{ item_detail.importer_name }}
              </v-flex>
              <v-flex xs12 sm6 md4>
                المخزن :
                {{ item_detail.store ? item_detail.store.name : "" }}
              </v-flex>

              <v-flex xs12 sm6 md4>
                السعر قبل الخصم :
                {{ item_detail.price_before }}
              </v-flex>
              <v-flex xs12 sm6 md4>
                السعر بعد الخصم :
                {{ item_detail.price_before }}
              </v-flex>
              <v-flex xs12 sm6 md4>
                التاريخ :
                {{ item_detail.created_at }}
              </v-flex>
            </v-layout>
            <hr />
            <v-data-table
              :headers="headers3"
              :items="item_detail.fatwora_items"
              class="elevation-1"
              :rows-per-page-items="rowsPerPageItems"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.item_name }}</td>
                <td>{{ props.item.item_num }}</td>
                <td>{{ props.item.item_num_reback }}</td>
                <td>{{ props.item.item_num_remain }}</td>
                <td>{{ props.item.price }}</td>
                <td>{{ props.item.total_reback_price }}</td>
              </template>
            </v-data-table>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="detail_dialog = false">
              موافق
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import {
  madionia_importer,
  search_fatwora_import_by_code,
  add_importer_fatwora_reback,
  stores,
  log_me
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    search: "",
    loading: false,
    stores: [],
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    headers: [
      {
        text: " كود",
        align: "right",
        value: "name"
      },
      { text: " سعر نهائي ", value: "rasid", align: "right" },
      { text: " اسم مورد", value: "control", sortable: false, align: "center" },
      {
        text: " موظف مسئول ",
        value: "control",
        sortable: false,
        align: "center"
      },
      { text: " التاريخ ", value: "control", sortable: false, align: "center" }
    ],
    headers2: [
      {
        text: " الصنف",
        align: "right",
        value: "name"
      },
      { text: " العدد الاصلي ", value: "rasid", align: "right" },
      {
        text: "المرتجع",
        value: "control",
        sortable: false,
        align: "center"
      },
      {
        text: "المتبقي",
        value: "control",
        sortable: false,
        align: "center"
      },
      {
        text: " سعر الوحدة",
        value: "control",
        sortable: false,
        align: "center"
      },
      {
        text: " السعر الكلي",
        value: "control",
        sortable: false,
        align: "center"
      }
    ],
    headers3: [
      {
        text: "الصنف ",
        align: "right",
        value: "item"
      },
      {
        text: " العدد قبل المرتجع",
        value: "client_name",
        sortable: false,
        align: "right"
      },
      {
        text: " المرتجع",
        value: "client_name",
        sortable: false,
        align: "right"
      },
      {
        text: " العدد المتبفي ",
        value: "client_name",
        sortable: false,
        align: "right"
      },
      {
        text: " سعر الوحدة",
        value: "client_name",
        sortable: false,
        align: "right"
      },
      {
        text: " السعر الكلي للمرتجع",
        value: "client_name",
        sortable: false,
        align: "right"
      }
    ],
    importer_fatwora_reback_items: [],
    importer_search_name: "",
    sadadstatuses: [],
    menu2: false,
    dialog2: false,
    modal2: false,
    date2: new Date().toISOString().substr(0, 10),
    newItem: {
      id: "",
      code: "",
      paper_code: "",
      price: "",
      fatwora_dicount: "",
      final_price: "",
      madionia_before: "",
      madionia_after: "",
      importer_name: "أختر المورد",
      sdad_type_name: "",
      sdad_status: "",
      emp_name: "",
      sadad_type_id: "",
      importer_id: "",
      emp_id: ""
    },
    madionia: {
      madionia_before: "",
      cost_or_money: "",
      madionia_after: "",
      emp_name: "",
      type_of_operation: "",
      code_of_operation: "",
      importer_id: "",
      emp_id: ""
    },
    importer_fatwora_original: {},
    importer_fatwora_reback: {
      code: "",
      price: "",
      fatwora_dicount_back: "",
      final_price: "",
      madionia_before: "",
      madionia_after: "",
      importer_name: "",
      emp_name: "",
      import_fatwora_id: "",
      importer_id: "",
      emp_id: "",
      store_id: ""
    },
    importer_fatworas_reback_of_code: [],
    added_items: [],
    item_detail: {},
    select_store: { id: "" },
    counter: 0,
    detail_dialog: false
  }),

  computed: {
    calc_remain: function() {
      return function(n, m) {
        if (m != "" && isNaN(m) && m > 0) {
          return parseInt(n) - parseInt(m);
        }
        return parseInt(n);
      };
    },
    gettotalpriceitem: function() {
      return function(q, p) {
        if (q > 0 && p > 0) {
          return parseInt(q) * parseFloat(p);
        }
        return 0;
      };
    },

    fatwora_price() {
      let tot_price = 0;
      for (
        let index = 0;
        index < this.importer_fatwora_reback_items.length;
        index++
      ) {
        tot_price += parseFloat(
          this.importer_fatwora_reback_items[index].total_reback_price
        );
      }
      if (tot_price > 0) {
        return (this.importer_fatwora_reback.price = tot_price);
      }
      return (this.importer_fatwora_reback.price = 0);
    },
    fatwora_final_price() {
      if (
        this.importer_fatwora_reback.price != "" &&
        this.importer_fatwora_reback.fatwora_dicount_back != ""
      ) {
        return (this.importer_fatwora_reback.final_price =
          parseFloat(this.importer_fatwora_reback.price) +
          parseFloat(this.importer_fatwora_reback.fatwora_dicount_back));
      }
      return (this.importer_fatwora_reback.final_price = this.importer_fatwora_reback.price);
    },
    madionia_now() {
      if (this.importer_fatwora_reback.final_price > 0) {
        return (this.importer_fatwora_reback.madionia_after =
          parseFloat(this.importer_fatwora_reback.madionia_before) -
          parseFloat(this.importer_fatwora_reback.final_price));
      }
      return (this.importer_fatwora_reback.madionia_after = this.importer_fatwora_reback.madionia_before);
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    // this.initialize()
    stores().then(response => {
      this.stores = response.data;
    });
    this.$watch(
      "importer_fatwora_reback_items",
      function() {
        this.importer_fatwora_reback.price = 0;
        let tot_price = 0;
        for (
          let index = 0;
          index < this.importer_fatwora_reback_items.length;
          index++
        ) {
          tot_price += parseFloat(
            this.importer_fatwora_reback_items[index].total_reback_price
          );
        }
        if (tot_price > 0) {
          this.importer_fatwora_reback.price = tot_price;
        }
      },
      { deep: true }
    );
    this.$watch(
      "importer_fatwora_reback.fatwora_dicount_back",
      function() {
        this.fatwora_final_price;
      },
      { deep: true }
    );
  },

  methods: {
    initialize() {},

    detailItem(item) {
      this.item_detail = item;
      this.detail_dialog = true;
    },

    code_calc() {
      if (this.importer_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.importer_fatworas[this.importer_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;

          this.madionia.madionia_before = this.importer_fatwora_reback.madionia_before;
          this.madionia.cost_or_money = this.importer_fatwora_reback.final_price;
          this.madionia.madionia_after = this.importer_fatwora_reback.madionia_after;
          this.madionia.emp_name = this.importer_fatwora_reback.emp_name;
          this.madionia.type_of_operation = "back";
          this.madionia.code_of_operation = this.importer_fatwora_reback.code;
          this.madionia.importer_id = this.importer_fatwora_reback.importer_id;
          this.madionia.emp_id = this.importer_fatwora_reback.emp_id;
          this.importer_fatwora_reback.store_id = this.select_store.id;

          var frmData = new FormData();
          frmData.append(
            "importer_fatwora_reback",
            JSON.stringify(this.importer_fatwora_reback)
          );
          frmData.append(
            "fatwora_reback_items",
            JSON.stringify(this.importer_fatwora_reback_items)
          );
          frmData.append("madionia", JSON.stringify(this.madionia));

          add_importer_fatwora_reback(frmData).then(response => {
            // Object.assign(this.$data.newItem, this.$options.data().newItem);
            this.loading = false;
            // Object.assign(this.$data.select_sadad_type, this.$options.data().select_sadad_type);
            // Object.assign(this.$data.select_importer, this.$options.data().select_importer);
            // Object.assign(this.$data.select_employer, this.$options.data().select_employer);
            // Object.assign(this.$data.added_items, this.$options.data().added_items);
            // Object.assign(this.$data.select_item, this.$options.data().select_item);
            // Object.assign(this.$data.select_sadadstatuses, this.$options.data().select_sadadstatuses);
            // Object.assign(this.$data.sadadstatuses, this.$options.data().sadadstatuses);
            //  this.importer_fatworas.push(response.data)

            //   setTimeout(() => {
            //    this.$refs.form.reset()
            //  }, 1000);
            let myUser = JSON.parse(localStorage.getItem("user"));
            var frmData3 = new FormData();
            frmData3.append("title", " مرتجع شراء");
            frmData3.append(
              "body",
              " ) تم مرتجع شراء فاتورة بكود " +
                this.importer_fatwora_reback.code +
                "( لمورد ) " +
                this.importer_fatwora_reback.importer_name +
                "( بواسطة )" +
                myUser.name +
                "( قيمتها )" +
                this.importer_fatwora_reback.final_price +
                " ) "
            );
            frmData3.append("type", "buy_reback_fatwora");
            frmData3.append("user_id", myUser.id);
            log_me(frmData3).then(response => {
              if (response.data == true) {
                let mytitle = "  مرتجع شراء";
                let mybody =
                  " - تم مرتجع شراء فاتورة بكود -" +
                  this.importer_fatwora_reback.code +
                  "- لمورد - " +
                  this.importer_fatwora_reback.importer_name +
                  "- بواسطة -" +
                  myUser.name +
                  "- قيمتها -" +
                  this.importer_fatwora_reback.final_price +
                  " - ";
                this.$toastr.warning(mybody, mytitle, {
                  closeButton: true,
                  progressBar: true,
                  positionClass: "toast-bottom-left",
                  preventDuplicates: false,
                  timeOut: "25000"
                });
              }
            });
            setInterval(() => {
              this.$router.go(0);
            }, 2000);
          });
        }
      });
    },
    search_fatwora_import_by_code() {
      this.loading = true;
      this.importer_fatworas_reback_of_code = [];
      search_fatwora_import_by_code(this.importer_search_name).then(
        response => {
          this.loading = false;
          let myUser = JSON.parse(localStorage.getItem("user"));
          this.importer_fatworas_reback_of_code = response.data.fatworas_reback;
          if (
            response.data.fatworas_reback &&
            response.data.fatworas_reback.length > 0 &&
            response.data.fatworas_reback[
              response.data.fatworas_reback.length - 1
            ].fatwora_items.length > 0
          ) {
            let all_of_arr = [];

            for (
              let i = 0;
              i <
              response.data.fatworas_reback[
                response.data.fatworas_reback.length - 1
              ].fatwora_items.length;
              i++
            ) {
              let in_object = {
                item_name: "",
                item_num: "",
                item_num_reback: "",
                item_num_remain: "",
                price: "",
                total_reback_price: "",
                item_id: ""
              };
              in_object.item_name =
                response.data.fatworas_reback[
                  response.data.fatworas_reback.length - 1
                ].fatwora_items[i].item_name;
              in_object.item_num =
                response.data.fatworas_reback[
                  response.data.fatworas_reback.length - 1
                ].fatwora_items[i].item_num_remain;
              in_object.item_num_reback = 0;
              in_object.item_num_remain =
                response.data.fatworas_reback[
                  response.data.fatworas_reback.length - 1
                ].fatwora_items[i].item_num_remain;
              in_object.price =
                response.data.fatworas_reback[
                  response.data.fatworas_reback.length - 1
                ].fatwora_items[i].price;
              in_object.total_reback_price = 0;
              in_object.item_id =
                response.data.fatworas_reback[
                  response.data.fatworas_reback.length - 1
                ].fatwora_items[i].item_id;
              all_of_arr.push(in_object);
            }
            this.importer_fatwora_reback_items = all_of_arr;
          } else {
            let all_of_arr = [];
            for (let j = 0; j < response.data.fatwora_items.length; j++) {
              let in_object = {
                item_name: "",
                item_num: "",
                item_num_reback: "",
                item_num_remain: "",
                price: "",
                total_reback_price: "",
                item_id: ""
              };
              in_object.item_name = response.data.fatwora_items[j].item_name;
              in_object.item_num = parseInt(
                response.data.fatwora_items[j].item_num
              );
              in_object.item_num_reback = 0;
              in_object.item_num_remain = parseInt(
                response.data.fatwora_items[j].item_num
              );
              in_object.price = response.data.fatwora_items[j].price;
              in_object.total_reback_price = 0;
              in_object.item_id = response.data.fatwora_items[j].item_id;
              all_of_arr.push(in_object);
            }

            this.importer_fatwora_reback_items = all_of_arr;
          }
          this.importer_fatwora_original = response.data;
          // this.importer_fatwora_reback_items = response.data.fatwora_items;

          let importer_id = response.data.importer_id;
          this.importer_fatwora_reback.code = response.data.code;
          this.importer_fatwora_reback.price = "";
          this.importer_fatwora_reback.fatwora_dicount_back = "";
          this.importer_fatwora_reback.final_price = "";
          this.importer_fatwora_reback.madionia_after = "";
          this.importer_fatwora_reback.importer_name =
            response.data.importer_name;
          this.importer_fatwora_reback.store_id = response.data.store_id;
          this.importer_fatwora_reback.emp_name = myUser.name;
          this.importer_fatwora_reback.import_fatwora_id = response.data.id;
          this.importer_fatwora_reback.importer_id = importer_id;
          this.importer_fatwora_reback.emp_id = myUser.id;
          this.select_store = {
            id: response.data.store_id,
            name: this.stores.filter(st => {
              return st.id == response.data.store_id;
            })[0].name
          };

          this.counter++;
          madionia_importer(importer_id).then(response => {
            let madion =
              response.data.madionia == 0 ? 0 : response.data.madionia;
            let rasid =
              response.data.importer &&
              response.data.importer.rasid_efttahi != null
                ? response.data.importer.rasid_efttahi
                : 0;
            this.importer_fatwora_reback.madionia_before =
              parseFloat(madion) + parseFloat(rasid);
          });

          // importer_fatwora_rebacks(this.importer_search_name).then(response => {
          //   this.importer_fatworas_reback_of_code = response.data;
          // });
        }
      );
    }
  }
};
</script>

<style scope>
.v-datatable__actions {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.flex,
.v-input.v-text-field,
.v-input__control {
  padding: 0px !important;
  margin: 0px !important;
}
.v-card__title,
.v-card__text {
  padding: 0px;
  margin: 0px;
}
@media print {
  body * {
    visibility: hidden;
  }
  .printMe,
  .printMe * {
    visibility: visible;
  }
  .printMe {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
